// extracted by mini-css-extract-plugin
module.exports = {"glacierTeaserPC":"treaser_glacierTeaserPC__AGPgr"};